const experiences = [
  {
    id: 1,
    period: '2025 - Present',
    role: 'Founder & Full Stack Developer',
    company: 'KXBYTE Digital Solutions',
    description:
      'Founded KXBYTE Digital Solutions and build full-stack web and mobile applications using the MERN stack. Developed scalable platforms including MoiHub, implemented REST APIs, authentication, cloud integrations, AI-powered features, and modern deployment workflows.',
    techs: [
      'React',
      'Node.js',
      'Express',
      'MongoDB',
      'React Native',
      'PostgreSQL',
      'Redis',
      'Firebase'
    ]
  },
  {
    id: 2,
    period: '2023 - Present',
    role: 'Founder & Lead Developer',
    company: 'MoiHub',
    description:
      'Designed and developed MoiHub, a campus marketplace connecting students with food vendors, e-shops, rentals, transport, and local services. Built both frontend and backend, vendor dashboards, payment integrations, notifications, and AI-assisted service discovery.',
    techs: [
      'React',
      'Node.js',
      'MongoDB',
      'React Native',
      'Cloudinary',
      'Firebase'
    ]
  },
  {
    id: 3,
    period: 'Aug 2024 - Sep 2024',
    role: 'Full Stack Web Developer',
    company: 'Nkosira Organic Farm',
    description:
      'Developed and maintained the company website, integrating responsive UI, backend functionality, and content management to improve the organization\'s online presence.',
    techs: ['JavaScript', 'PHP', 'MySQL', 'WordPress']
  },
  
  {
    id: 4,
    period: 'Sep 2023 - Dec 2023',
    role: 'Junior Web Developer',
    company: 'Vasto Group',
    description:
      'Contributed to frontend development, bug fixes, and UI implementation while gaining experience in collaborative software development workflows.',
    techs: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'jQuery']
  }
];

export default experiences;